import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
}

const toneClasses: Record<Tone, string> = {
  neutral: 'bg-brand-gray-light text-brand-charcoal',
  success: 'bg-brand-success/15 text-brand-success',
  warning: 'bg-brand-warning/15 text-brand-warning',
  danger: 'bg-brand-danger/15 text-brand-danger',
  info: 'bg-brand-blue/15 text-brand-blue',
};

export function Badge({ tone = 'neutral', className, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm px-1.5 py-0.5 text-xs font-medium',
        toneClasses[tone],
        className,
      )}
      {...rest}
    />
  );
}
